import { put, call, takeLatest, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import customerAPI from '../../api/customer';
import { Creators as AppCreators } from '../../reducers/app';
import { Types, Creators } from '../../reducers/customer';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* customerDocRequest({ document }) {
  try {
    const { app, customer } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);
    const token = yield select(getToken);
    const customerId = customer.getIn(['id']);

    const data = yield call(customerAPI.document, siteId, customerId, token, document);

    yield put(Creators.customerDocSuccess(data));
    yield put(AppCreators.feedbackRequest({ open: true, message: 'Arquivo enviado com sucesso', type: 'success' }));
    yield put(Creators.customerInfosRequest());
  } catch (error) {
    const formatted = formatError(error);
    yield put(Creators.customerDocFailed(formatted));
    yield put(AppCreators.feedbackRequest({ open: true, message: formatted.message }));
  }
}

export default function* watch() {
  yield takeLatest(Types.CUSTOMER_DOC_REQUEST, customerDocRequest);
}
